// Which sessions on a Mac wait on the person — a permission or a question (docs/features/home-redesign.md, the Needs
// you strip; the headset's HomeCatalog reads the same from its store). One per client: the pending asks of the
// folders its recent sessions are in, then kept up to date from opencode's events.
//
// One seam: `asksOf(client, request)` → `{ waiting(sessionID) → bool, count }`.
const trackers = new WeakMap()

class PendingAsks {
  constructor(client, request) {
    this.client = client
    this.asks = new Map()       // ask id → sessionID
    this.parents = new Map()    // child session → its parent (a subagent's ask counts for the session that started it)
    client.onEvent?.((raw) => this.event(raw?.payload || raw))
    const dirs = [...new Set((client.sessions || []).slice(0, 8).map((s) => s.directory).filter(Boolean))]
    for (const directory of dirs) {
      for (const route of ['permission', 'question']) {
        request('GET', route, { query: { directory } }).then((list) => { for (const x of list || []) if (x?.id && x.sessionID) this.asks.set(x.id, x.sessionID) }, () => {})
      }
    }
  }
  event({ type, properties: p = {} } = {}) {
    if ((type === 'session.created' || type === 'session.updated') && p.info?.parentID) this.parents.set(p.info.id, p.info.parentID)
    else if ((type === 'permission.asked' || type === 'permission.updated' || type === 'question.asked') && p.id && p.sessionID) this.asks.set(p.id, p.sessionID)
    else if (type === 'permission.replied' || type === 'question.replied' || type === 'question.rejected') this.asks.delete(p.requestID || p.permissionID || p.id)
  }
  top(id) { let at = id; for (let i = 0; i < 8 && this.parents.has(at); i++) at = this.parents.get(at); return at }
  waiting(sessionID) { for (const s of this.asks.values()) if (s === sessionID || this.top(s) === sessionID) return true; return false }
  get count() { return this.asks.size }
}

export function asksOf(client, request) {
  if (!client) return null
  let t = trackers.get(client)
  if (!t) { t = new PendingAsks(client, request); trackers.set(client, t) }
  return t
}
